import {AuthState} from './auth.models';
import {authLogin, authLoginSuccess, authLoginUsernamePassword, authLoginFail, authLogout} from './auth.actions';
import {Action, createReducer, on} from '@ngrx/store';

export const initialState: AuthState = {
    isAuthenticated: false,    
    usernameAndPassword: {
        username: '',
        password: '',
    },
    errLogin: null,
    userProfile: {
        userId: '',
        name: '',
        firstName: '',
        lastName: '',
        userName: '',
        email: '',
        picture: 'assets/images/avatars/no-avatar.png'
    }
};

const reducer = createReducer(
    initialState,
    on(authLogin, (state) => ({
        ...state,
        isAuthenticated: true,
        usernameAndPassword: {
            username: '',
            password: '',
        }
    })),
    on(authLoginUsernamePassword, (state, usernameAndPassword) => ({
        ...state,
        isAuthenticated: false,
        usernameAndPassword: {
            username: usernameAndPassword.username,
            password: usernameAndPassword.password,
        }
    })),
    on(authLoginSuccess, (state, props) => ({
        ...state,
        isAuthenticated: true,
        usernameAndPassword: {
            username: '',
            password: '',
        },
        userProfile: props.userProfile
    })),
    on(authLoginFail, (state, props) => ({
        ...state,
        isAuthenticated: false,
        errLogin: props.err
    })),
    on(authLogout, (state) => ({...state, ...initialState}))
);

export function authReducer(
    state: AuthState | undefined,
    action: Action
): AuthState {
    return reducer(state, action);
}
